export default __webpack_public_path__ + "static/media/purchase-item-detail.8f4dcb3d.jpg";